import type { Units } from '@turf/helpers';

export type UnitSystem = 'metric' | 'imperial';

export type UnitSystemData = {
  id: UnitSystem;
  area: number;
  areaUnit: Units;
  distance: Units;
  distancePerHourConversionFactor: number;
  shortTranslationKey: string;
  longTranslationKey: string;
  temperatureSymbol: string;
  distancePerHourShort: string;
};

export const UnitSystems: Record<UnitSystem, UnitSystemData> = {
  metric: {
    id: 'metric',
    area: 1,
    areaUnit: 'hectares',
    distance: 'kilometers',
    distancePerHourConversionFactor: 1,
    shortTranslationKey: 'units.area_metric_short',
    longTranslationKey: 'units.area_metric_long',
    temperatureSymbol: '°C',
    distancePerHourShort: 'km/h',
  },
  imperial: {
    id: 'imperial',
    area: 0.404686,
    areaUnit: 'acres',
    distance: 'miles',
    distancePerHourConversionFactor: 0.621371,
    shortTranslationKey: 'units.area_imperial_short',
    longTranslationKey: 'units.area_imperial_long',
    temperatureSymbol: '°F',
    distancePerHourShort: 'mph',
  },
} as const;

export const getUnitSystem = (key: string) => {
  switch (key.toLowerCase()) {
    case 'imperial':
    case 'acre':
    case 'acres':
      return UnitSystems['imperial'];
    case 'metric':
    case 'hectares':
      return UnitSystems['metric'];
    default:
      return UnitSystems['metric'];
  }
};
